export default function OrdersButton({ count, active, onPress }) {

    const formattedCount = count > 99 ? '99+' : String(count)

    return (
        <a role="button" className="logined-link logined-link__orders" onClick={onPress}>
            {count > 0 && <span className={cn(active && 'active')}>{formattedCount}</span>}
            <i className="icon-list2"></i>
            {__('menu.orders')}
        </a>
    )
}
